import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import titleImage from "../../assets/images/titleImage.png";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import TourCardIndividual from "../../components/TourCard/TourCardIndividual";
import NotFound from "../../components/Loading/NotFound";
import api from "../../api/client";
import SeoMeta from "../../components/SeoMeta";
import {getWishlist} from "../../components/wishList/wishlist";
import s from "../TourDetails/TourDetails.module.scss";

const Wishlist = () => {

    const [tours, setTours] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchWishlist = async () => {
        try {
            setLoading(true);

            const wishlistIds = getWishlist();

            if (!wishlistIds || wishlistIds.length === 0) {
                setTours([]);
                return;
            }

            const response = await api.post("/api/tour/wishlist", {
                rezdy_ids: wishlistIds
            });
            // const responseText = await responseTxt.text();

            console.log( response);
            // const response = JSON.parse(responseTxt);
            setTours(response.data.data);
        } catch (error) {
            console.error("Failed to fetch wishlist:", error);
            setTours([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWishlist();
    }, []);

    /**
     * Listen for wishlist changes.
     *
     * This allows the page to refresh when the wishlist is changed
     * from another component.
     */
    useEffect(() => {
        const handleWishlistChange = () => {
            fetchWishlist();
        };

        window.addEventListener("wishlistChanged", handleWishlistChange);

        return () => {
            window.removeEventListener(
                "wishlistChanged",
                handleWishlistChange
            );
        };
    }, []);

    const breadcrumbItems = [
        {
            name: "ホーム",
            link: "/"
        },
        {
            name: "お気に入り"
        }
    ];

    return (
        <>
            <SeoMeta
                slug={window.location.pathname}
                fallback={{
                    title: "お気に入り",
                    description: "お気に入りに登録したツアー",
                    image: "",
                    url: `${process.env.REACT_APP_URL}${window.location.pathname}`
                }}
            />

            <div className="row mt-3 mb-3">
                <div className="col-12">

                    <Breadcrumb items={breadcrumbItems}/>

                    <div className={s.titleWrrapper}>
                        <img
                            className={s.titleImage}
                            src={titleImage}
                            alt=""
                        />

                        <h2 className={s.primaryTitle}>
                            お気に入り
                        </h2>

                        <h3 className={s.secondaryTitle}>
                            Favorite Tours
                        </h3>
                    </div>

                </div>
            </div>

            <div className="row">
                <div className="col-12">

                    {loading && (
                        <div className="row mt-5">
                            {Array.from({length: 8}).map((_, index) => (
                                <div
                                    className="col-6 col-lg-4 col-xl-3 mb-4"
                                    key={index}
                                >
                                    <TourCardIndividual loading/>
                                </div>
                            ))}
                        </div>
                    )}

                    {!loading && tours.length > 0 && (
                        <div className="row mt-5">

                            {tours.map((tour) => (
                                <div
                                    className="col-6 col-lg-4 col-xl-3 mb-4"
                                    key={tour.id || tour.rezdy_id}
                                >
                                    <TourCardIndividual item={tour}/>
                                </div>
                            ))}

                        </div>
                    )}

                    {!loading && tours.length === 0 && (
                        <div className={s.emptyWishlist}>
                            <div className={s.emptyWishlistIcon}>
                                ♥
                            </div>

                            <h3>
                                お気に入りのツアーはありません
                            </h3>

                            <p>
                                気になるツアーをお気に入りに追加して、
                                いつでもチェックできます。
                            </p>

                            <Link
                                to="/all-tours"
                                className={s.browseToursButton}
                            >
                                ツアーを見る
                            </Link>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
};

export default Wishlist;